import React, { useState } from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import Link from './Link'
import InfoIcon from '../../assets/images/infoIcon.svg'
import * as styles from './hero.module.css'
import DownCaret from '../../assets/images/downcaretWhite.svg'

export default ({ title, subtitle, images, mobileOnlyImages, components }) => {
  const [displayMobileDesc, setMobileDescVisibility] = useState(false)
  const isMobile = typeof window !== `undefined` && window.innerWidth <= 500
  let image = images[0]
  if (isMobile && mobileOnlyImages) {
    image = mobileOnlyImages[0]
  }

  return (
    <div className={styles.hero}>
      <GatsbyImage
        image={image.iphero}
        className={styles.heroImage}
        alt={image?.description}
      />
      <div className={styles.description}>{image.description}</div>

      {image.description != null && image.description.length > 0 && (
        <InfoIcon
          className={styles.infoIcon}
          onClick={() => setMobileDescVisibility(!displayMobileDesc)}
        />
      )}

      <div
        className={styles.mobileDescriptionBox}
        style={{ display: displayMobileDesc ? 'block' : 'none' }}
      >
        <div className={styles.mobileDescription}>{image.description}</div>
        <DownCaret className={styles.downCaret} />
      </div>

      <div className={styles.heroDetails}>
        <h1 className={styles.heroTitle}>{title}</h1>
        {subtitle != null && (
          <p className={styles.heroSubtitle}>{subtitle.subtitle}</p>
        )}
        {components != null &&
          components.length > 0 &&
          components.map((link, idx) => (
            <Link to={link.ctaUrl} className={styles.buttonLink} key={idx}>
              {link.ctaText}
            </Link>
          ))}
      </div>
    </div>
  )
}
